(function($) {
    var burgerButton = $('.burger-button');
    var languageSwitcher = $('.wpml-ls-current-language > a');
    var languageDropdown = $('.wpml-ls-current-language .sub-menu');

    var header = $('.header');

    burgerButton.on('click', function(event) {
        event.preventDefault();
        $(event.currentTarget).toggleClass('--is-active');
        $('.main-navigation').toggleClass('--is-active');
    })
    $(window).scroll(function(){
        if ($(window).scrollTop() >= 250) {
          header.addClass('header--sticky');
         }
         else {
          header.removeClass('header--sticky');
         }
      });
      


    languageSwitcher.on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        languageDropdown.slideToggle('fast');
        $('.wpml-ls-current-language').toggleClass('--is-open');
        

        languageDropdown.on('click', function(event) { 
            event.stopPropagation();
          })

        $(document).on('click', function(event) {
            event.stopPropagation();
            $('.wpml-ls-current-language').removeClass('--is-open');
            languageDropdown.slideUp('fast');
        })
    })



    

    
    //Fast solution


    $('.module-pages-block').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        rows: 1,
        variableWidth: true,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        responsive: [
            {
              breakpoint: 998,
              settings: {
                variableWidth: false,
                slidesToShow: 1
              },
            }
        ]
      });
    
}(jQuery))

